import { UserLocation } from 'src/api/types';
import useLocationStore from './useLocationStore';
import useStoreDeep from './useStore';
import useServerUserLocationStore from './useServerUserLocationStore';

const useUserLocation = (): UserLocation => {
  const userLocation = useStoreDeep(
    useLocationStore,
    (state) => state.userLocation
  );
  const { serverUserLocation } = useServerUserLocationStore();

  return userLocation ?? serverUserLocation;
};

export default useUserLocation;
